import { DialogController } from 'aurelia-dialog';
import { EventAggregator, Subscription } from 'aurelia-event-aggregator';
import { autoinject } from 'aurelia-framework';

@autoinject
export class AlertDialog {
  private routerSubscription: Subscription;

  constructor(private dialogController: DialogController, private ea: EventAggregator) { }

  activate(options: PartialOptions) {
    Object.assign(this, new AlertOptions(), options);
  }

  attached() {
    if (this['closeOnNavigation'] === true)
      this.routerSubscription = this.ea.subscribe('router:navigation:complete', () => this.dialogController.ok());
  }

  detached() {
    if (this.routerSubscription != null)
      this.routerSubscription.dispose();
  }

  ok() {
    this.dialogController.ok();
  }
}

class AlertOptions {
  dialogTitle = 'Message';
  okTitle = 'OK';
  message: string = null;
  details: string[] = null;
  class: string = null;
  icon: string = null;
  closeOnNavigation = false;
}

type PartialOptions = Partial<AlertOptions>;
export { PartialOptions as AlertOptions };
